import Vue from 'vue'
import { AclInstaller, AclCreate, AclRule } from 'vue-acl'
import router from '@/router'
import { getApplicationLocalStorageItem } from '../helpers'

Vue.use(AclInstaller)

let initialRole = 'editor'

if (JSON.parse(getApplicationLocalStorageItem('user')) && JSON.parse(getApplicationLocalStorageItem('user')).is_admin) {
  initialRole = 'admin'
}

export default new AclCreate({
  initial  : initialRole,
  notfound : '/pages/not-authorized',
  router,
  acceptLocalRules : true,
  globalRules: {
    admin  : new AclRule('admin').generate(),
    editor : new AclRule('editor').or('admin').generate()
  }
})
